/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import {  } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type CartNav_user = {
    readonly preferences: {
        readonly currency: Currency | null;
    } | null;
    readonly " $refType": "CartNav_user";
};
export type CartNav_user$data = CartNav_user;
export type CartNav_user$key = {
    readonly " $data"?: CartNav_user$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"CartNav_user">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CartNav_user",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "preferences",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currency",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "User",
    "abstractKey": null
} as any;
(node as any).hash = '07d71cd5390cadb4431b06d42a73f5b4';
export default node;
